const steps = {
  start: {
    message: `👋Вітаю,
      Щоб розпочати спілкування натисність кнопку «Привіт» нижче.`,
    options: [{ label: "Привіт !😊", next: "bot_start_btns" }],
  },
  bot_start_btns: {
    message: `Привіт! 😊 Звягельський  політехнічний фаховий коледж — це твій крок у світ сучасних технологій.<br/> Давай разом знайдемо відповіді на твої питання!🔍<br/><br/>
Оберіть категорію нижче ⬇️
`,
    options: [
      { label: "📅 Розклад занять", next: "schedule" },
      { label: "🛎️ Розклад дзвінків", next: "bells_schedule" },
      { label: "📢 Новини/Заходи", next: "news" },
      { label: "📊 Рейтингові списки", next: "rating_lists" },
      { label: "📆 Графік сесій/заліків", next: "session_schedule" },
      { label: "🏠 Гуртожиток", next: "hostel" },
      { label: "📌 Вступ до коледжу", next: "college_vstup" },
      { label: "☎️ Контакти", next: "contacts" },
      { label: "📥 Скринька довіри", next: "open_complaint_form" }, 
    ],
  },
  schedule: {
    message: `✅ Окей, тримай розклад!<br/><br/>
Перевір актуальний розклад занять
 🔗<a target="_blank" rel="noopener noreferrer" href="http://nvpet.novograd.info/?cat=47">тут</a>.`,
    options: [
      { label: "⬅️ Назад ", next: "bot_start_btns" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  bells_schedule: {
    message: `🛎️ Розклад дзвінків<br/><br/>
Привіт! 👋
Хочеш знати, коли перерва на каву? ☕😉<br/><br/>
Тримай свій розклад пар у ЗПФК:<br/>
📅 Понеділок, середа — субота:<br/>
  🕗 1 пара:  08:00 – 09:20<br/>
  🕘 2 пара:  09:30 – 10:50<br/>
  🕚 3 пара:  11:20 – 12:40<br/>
  🕛 4 пара:  12:50 – 14:10<br/>
  🕐 5 пара:  14:20 – 15:40<br/>
  🕑 6 пара:  16:10 – 17:30<br/>
  🕒 7 пара:   17:40 – 19:00<br/><br/>
________________________________________<br/><br/>
📅 Вівторок:<br/>
👥 Виховна година:<br/> 
   🕛 4 пара:  12:50 – 13:20<br/>
   🕛 5 пара:  13:30 – 14:50<br/>
    🕛 6 пара:  15:00 – 16:20<br/>
    🕛 7 пара:  16:50 – 18:10<br/><br/>
    ❗ Можливі зміни, уточнюйте у класного керівника або на 🔗<a target="_blank" rel="noopener noreferrer" href="http://nvpet.novograd.info">сайті</a>  коледжу. `,
    options: [
      { label: "⬅️ Назад ", next: "bot_start_btns" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  news: {
    message: `✅ Є контакт!<br/>
Усі свіжі новини та події — тут: 🔗<a target="_blank" rel="noopener noreferrer" href="http://nvpet.novograd.info">тут</a>`,
    options: [
      { label: "⬅️ Назад ", next: "bot_start_btns" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },

  rating_lists: {
    message: `✅ Все готово для Вас!<br/>
Перевіряй рейтингові списки натиснувши 🔗<a target="_blank" rel="noopener noreferrer" href="http://nvpet.novograd.info/?cat=55">сюди</a>`,
    options: [
      { label: "⬅️ Назад ", next: "bot_start_btns" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  session_schedule: {
    message: `📚 Сесія не питає, сесія приходить...<br/><br/>
    Щоб вчасно дізнаватися про актуальний графік сесій та заліків настискай
🔗<a target="_blank" rel="noopener noreferrer" href="http://nvpet.novograd.info/?cat=56">сюди</a>`,
    options: [
      { label: "⬅️ Назад ", next: "bot_start_btns" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  hostel: {
    message: `✅ Оберіть, що вас цікавить:`,
    options: [
      { label: "🎉 Події в гуртожитку", next: "events_in_hostel" },
      { label: "📄 Документи для поселення", next: "documents_for_hostel" },
    ],
  },
  events_in_hostel: {
    message: `🔥 Гуртожиток — це не тільки про сон і сесію 😉<br/><br/>
На тебе чекають:<br/>
– Вечори знайомств <br/>
– Тематичні вечірки<br/>
– Благодійні заходи<br/>
– Культурні ініціативи<br/>
Переглянути актуальні заходи в гуртожитку можна натиснувши
 🔗<a target="_blank" rel="noopener noreferrer" href="http://nvpet.novograd.info/?cat=34">сюди</a>`,
    options: [
      { label: "⬅️ Назад ", next: "hostel" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },

  documents_for_hostel: {
    message: `📄 Документи для поселення<br/><br/>
            ✅ Для поселення в гуртожиток ЗПФК необхідно надати:<br/><br/>
            📌 Основні документи:<br/>
            – 📝 Заява<br/>
            – 🩻 Флюорографія<br/>
            – 🧴 Довідка від дерматолога<br/>
            – 🏠 Довідка про епідоточення (дійсна 3 дні)<br/>
            – 💵 Квитанція про оплату за гуртожиток (за 5 місяців)<br/><br/>
            📌 Додатково для студентів першого курсу:<br/><br/>
            – 🖼️ 2 фотокартки 3×4 (для оформлення перепустки)<br/>
            – 🆔 Паспорт (ID-картка) для оформлення реєстрації<br/>
            👉 Актуальний перелік документів за посиланням: 🔗<a target="_blank" rel="noopener noreferrer" href="http://nvpet.novograd.info/?p=5199">перейти до інформації</a><br/>`,
    options: [
      { label: "⬅️ Назад ", next: "hostel" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  college_vstup: {
    message: `👩‍💻Оберіть, яка інформація вас цікавить:`,
    options: [
      { label: "📄 Документи для вступу", next: "documents_for_college" },
      { label: "🧑‍🎓 Спеціальності", next: "spec_list" },
      { label: "📚 Підготовчі курси", next: "courses" },
      { label: "💰 Вартість навчання", next: "cost_of_studiyng" },
    ],
  },
  documents_for_college: {
    message: `✅ Щоб подати заяву на вступ до коледжу, вам знадобляться такі документи:</br></br>
    🆔 Паспорт або ID-картка</br>
    🎓 Документ про освіту (свідоцтво або атестат)</br>
    🖼️ Фотографії 3×4 — 4 шт.</br>
    🏥 Медична довідка (форма 086-О)</br>
    📄 Ідентифікаційний код (копія)</br>
    📘 Документи, що дають право на пільги (за наявності)</br></br>
    Детальну інформацію можна уточнити у приймальній комісії або на сайті 😊.`,
    options: [
      { label: "⬅️ Назад ", next: "college_vstup" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  spec_list: {
    message: `
      🎓 Заклад пропонує здобуття освіти за такими спеціальностями:<br /><br />
      💻 <strong>F7 - КОМП'ЮТЕРНА ІНЖЕНЕРІЯ</strong><br />
      Комп’ютерна інженерія — напрям для тих, хто хоче розвиватися у сфері ІТ, програмування та обслуговування комп’ютерних систем.<br /><br />
      📊 <strong>D1 - ОБЛІК ТА ОПОДАТКУВАННЯ</strong><br />
      Бухгалтерський облік — класична економічна спеціальність для тих, хто прагне працювати у сфері фінансів, аудиту та управлінського обліку.<br /><br />
      🔥 <strong>G19 - БУДІВНИЦТВО ТА ЦИВІЛЬНА ІНЖЕНЕРІЯ</strong><br />
      Монтаж, обслуговування устаткування і систем газопостачання — фахівці з цієї галузі затребувані у сфері енергетичної та ЖКG.<br /><br />
      ⚡ <strong>G3 - ЕЛЕКТРОЕНЕРГЕТИКА, ЕЛЕКТРОТЕХНІКА, ЕЛЕКТРОМЕХАНІКА</strong><br />
      Монтаж і експлуатація електроустаткування підприємств і цивільних споруд — підготовка спеціалістів для енергетичної та будівельної галузей.<br /><br />
      🔧 <strong>G3 - ЕЛЕКТРОЕНЕРГЕТИКА, ЕЛЕКТРОТЕХНІКА, ЕЛЕКТРОМЕХАНІКА</strong><br />
      Обслуговування та ремонт електроустаткування автомобілів і тракторів — спеціальність для майбутніх автоелектриків, які бажають працювати з сучасною автотехнікою.<br /><br />
      🛠️ <strong>G9 - ПРИКЛАДНА МЕХАНІКА</strong><br />
      Технічне обслуговування і ремонт устаткування підприємств машинобудування — орієнтована на підготовку механіків, ремонтників і технічних інженерів.<br />`,
    options: [
      { label: "⬅️ Назад ", next: "college_vstup" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  courses: {
    message: `🎓Коледж проводить підготовчі курси для учнів 9-х класів, які планують вступати до навчального закладу.</br>🏫
    Курси допоможуть краще підготуватися до вступних випробувань, ознайомитися зі спеціальностями та адаптуватися до майбутнього студентського життя. 📖</br>
    💬 Якщо хочеш бути впевненим(ою) у своїх знаннях та зробити крок назустріч майбутній професії — приєднуйся вже зараз! 🚀</br>
    👉 Детальніше за <a target="_blank" href = "http://nvpet.novograd.info/?cat=25">посиланням</a>`,
    options: [
      { label: "⬅️ Назад ", next: "college_vstup" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  cost_of_studiyng: {
    message: `🔎 Яка спеціальність вас цікавить? Оберіть одну з наведених нижче, щоб дізнатися про вартість навчання:`,
    options: [
      { label: "💻 Комп’ютерна інженерія", next: "computer_engineer" },
      { label: "📚  Облік і оподаткування", next: "bugalter" },
      {
        label: "🔥 Будівництво та цивільна інженерія",
        next: "civil_engineering",
      },
      {
        label:
          "⚡ Електроенергетика, електротехніка, електромеханіка(Електрик)",
        next: "electric",
      },
      {
        label:
          "🔧 Електроенергетика, електротехніка, електромеханіка(Автоелектрик)",
        next: "autoelectric",
      },
      { label: "🛠️ Прикладна механіка", next: "mechanic" },
    ],
  },
  computer_engineer: {
    message: `💻 Комп’ютерна інженерія <br/><br/>

🆔 Код спеціальності: F7<br/>
📅 Термін навчання:<br/><br/>

• На базі 9 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2029<br/>
💵 Загальна вартість: 100 400 грн<br/>
– І курс: 23 300 грн<br/>
– ІІ курс: 24 460 грн<br/>
– ІІІ курс: 25 680 грн<br/>
– ІV курс: 26 960 грн<br/>
• На базі 11 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2028<br/>
💵 Загальна вартість: 73 440 грн<br/><br/>

– ІІ курс: 23 300 грн<br/>
– ІІІ курс: 24 460 грн<br/>
– ІV курс: 25 680 грн<br/><br/>
👉 Актуальна інформація за <a target="_blank" rel="noopener noreferrer" href = "http://nvpet.novograd.info/?cat=30">посиланням<a/>`,
    options: [
      { label: "⬅️ Назад ", next: "cost_of_studiyng" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },

  bugalter: {
    message: `📚 Облік і оподаткування (бухгалтерія)<br/><br/>

🆔 Код спеціальності: D1<br/>
📅 Термін навчання:<br/><br/>

• На базі 9 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2028<br/>
💵 Загальна вартість: 66 830 грн<br/>
– І курс: 21 200 грн<br/>
– ІІ курс: 22 260 грн<br/>
– ІІІ курс: 23 370 грн<br/>
• На базі 11 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2027<br/>
💵 Загальна вартість: 43 460 грн<br/>
– ІІ курс: 21 200 грн<br/>
– ІІІ курс: 22 260 грн<br/><br/>
👉 Актуальна інформація за <a target="_blank" rel="noopener noreferrer" href = "http://nvpet.novograd.info/?cat=28">посиланням<a/>`,
    options: [
      { label: "⬅️ Назад ", next: "cost_of_studiyng" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  civil_engineering: {
    message: `🔥 Будівництво та цивільна інженерія <br/><br/>

🆔 Код спеціальності: G19<br/>
📅 Термін навчання:<br/><br/>

• На базі 9 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2029<br/>
💵 Загальна вартість: 87 920 грн<br/>
– І курс: 20 400 грн<br/>
– ІІ курс: 21 420 грн<br/>
– ІІІ курс: 22 490 грн<br/>
– ІV курс: 23 610 грн<br/>
• На базі 11 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2028<br/>
💵 Загальна вартість: 64 310 грн<br/>
– ІІ курс: 20 400 грн<br/>
– ІІІ курс: 21 420 грн<br/>
– ІV курс: 22 490 грн<br/><br/>
👉 Актуальна інформація за <a target="_blank" rel="noopener noreferrer" href = "http://nvpet.novograd.info/?cat=29">посиланням<a/>`,
    options: [
      { label: "⬅️ Назад ", next: "cost_of_studiyng" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  electric: {
    message: `⚡ Електроенергетика, електротехніка, електромеханіка (Електрик)<br/><br/>
🆔 Код спеціальності: G3<br/><br/>
📅 Термін навчання:<br/><br/>

• На базі 9 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2029<br/><br/>
💵 Загальна вартість: 100 400 грн<br/><br/>
– І курс: 23 300 грн<br/>
– ІІ курс: 24 460 грн<br/>
– ІІІ курс: 25 680 грн<br/>
– ІV курс: 26 960 грн<br/>
• На базі 11 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2028<br/>
💵 Загальна вартість: 73 440 грн<br/>
– ІІ курс: 23 300 грн<br/>
– ІІІ курс: 24 460 грн<br/>
– ІV курс: 25 680 грн<br/><br/>
👉 Актуальна інформація за <a target="_blank" rel="noopener noreferrer" href = "http://nvpet.novograd.info/?cat=29">посиланням<a/>`,
    options: [
      { label: "⬅️ Назад ", next: "cost_of_studiyng" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  mechanic: {
    message: `🛠️ Прикладна механіка <br/><br/>
🆔 Код спеціальності: G9<br/><br/>
📅 Термін навчання:<br/><br/>

• На базі 9 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2029<br/>
💵 Загальна вартість: 87 920 грн<br/>
– І курс: 20 400 грн<br/>
– ІІ курс: 21 420 грн<br/>
– ІІІ курс: 22 490 грн<br/>
– ІV курс: 23 610 грн<br/>
• На базі 11 класів:<br/>
⏳ 1 вересня 2025 — 30 червня 2028<br/>
💵 Загальна вартість: 64 310 грн<br/>
– ІІ курс: 20 400 грн<br/>
– ІІІ курс: 21 420 грн<br/>
– ІV курс: 22 490 грн<br/><br/>
👉 Актуальна інформація за <a target="_blank" rel="noopener noreferrer" href = "http://nvpet.novograd.info/?cat=29">посиланням<a/>`,
    options: [
      { label: "⬅️ Назад ", next: "cost_of_studiyng" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
  autoelectric: {
    message: `⚡ Електроенергетика, електротехніка, електромеханіка (Автоелектрик)</br></br>
🆔 Код спеціальності: G3</br>
📅 Термін навчання:</br></br>

• На базі 9 класів:</br>
⏳ 1 вересня 2025 — 30 червня 2029</br>
💵 Загальна вартість: 100 400 грн</br>
– І курс: 23 300 грн</br>
– ІІ курс: 24 460 грн</br>
– ІІІ курс: 25 680 грн</br>
– ІV курс: 26 960 грн</br>
• На базі 11 класів:</br>
⏳ 1 вересня 2025 — 30 червня 2028</br>
💵 Загальна вартість: 73 440 грн</br>
– ІІ курс: 23 300 грн</br>
– ІІІ курс: 24 460 грн</br>
– ІV курс: 25 680 грн</br></br>
👉 Актуальна інформація за <a target="_blank" rel="noopener noreferrer" href = "http://nvpet.novograd.info/?cat=29">посиланням<a/>`,
    options: [
      { label: "⬅️ Назад ", next: "cost_of_studiyng" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },

  contacts: {
    message: `✅ Ось контакти Звягельського політехнічного фахового коледжу:</br></br>
📞 Телефон: +38 (068) 816 88 80</br>
📧 Email: nvpet@i.ua</br>
📍 Адреса: вул. Шевченка, 38, м. Звягель</br>`,
    options: [
      { label: "⬅️ Назад ", next: "bot_start_btns" },
      { label: "🏠 Головне меню ", next: "bot_start_btns" },
    ],
  },
};

export default steps;